import { LinearGradient } from 'expo-linear-gradient';
import { View, XStack, YStack } from 'tamagui';

import { GRADIENT_COLOR_BOTTOM, GRADIENT_COLOR_TOP } from '../../constants';
import { Button, ButtonSize, ButtonVariant } from '../buttons/Button';
import { Icon, type IconType } from '../icons/Icon';
import { Shadows } from '../Shadows';
import { BodySmallRegular } from '../text/Typography';

interface MemberTipButtonProps {
    text: string;
    onPress?: () => void;
    icon?: IconType;
}

interface MemberTipProps {
    icon: IconType;
    text: string;
    button?: MemberTipButtonProps;
}

export const MemberTip = ({ icon, text, button }: MemberTipProps) => {
    return (
        <View borderRadius={24} {...Shadows.MEDIUM}>
            <LinearGradient
                colors={[GRADIENT_COLOR_TOP, GRADIENT_COLOR_BOTTOM]}
                start={{ x: 0, y: 0 }}
                end={{ x: 0, y: 1 }}
                locations={[0, 0.7]}
                style={{
                    width: '100%',
                    borderRadius: 24,
                    padding: 20,
                    gap: 12,
                    overflow: 'hidden',
                }}
            >
                <XStack gap={12} alignItems="flex-start" flex={1}>
                    <YStack paddingTop={2}>
                        <Icon icon={icon} size={24} color="$black" />
                    </YStack>
                    <YStack flex={1} justifyContent="center">
                        <BodySmallRegular color="$black" fontStyle="italic">
                            {text}
                        </BodySmallRegular>
                    </YStack>
                </XStack>

                {button != null && (
                    <XStack width="100%">
                        <Button
                            text={button.text}
                            variant={ButtonVariant.SECONDARY}
                            size={ButtonSize.SMALL}
                            width="full"
                            onPress={button.onPress}
                            buttonProps={{
                                backgroundColor: '$white',
                            }}
                            {...(button.icon != null && { icon: button.icon })}
                        />
                    </XStack>
                )}
            </LinearGradient>
        </View>
    );
};
